import React, { useEffect, useState } from "react";
import "../../CSS/ItemMaster.css";
import axios from "axios";
import LoadingScreen from "../LoadingScreen";
import "jspdf-autotable";
import { FaArrowLeft } from "react-icons/fa";
import moment from "moment";
import { useSelector } from "react-redux";
import Select from "react-select";

const VehiclesExpectedInWorkshop = () => {
  const BASEURL_GLOBAL = process.env.REACT_APP_BASEURL_GLOBAL;
  const BASEURL = process.env.REACT_APP_BASEURL;
  const authToken = window.sessionStorage.getItem("auth-token");
  const sessionToken = window.sessionStorage.getItem("session-token");
  const [isloading, setisloading] = useState(true);
  const [search, setSearch] = useState("");
  const state = useSelector((state) => state.changeTheState.user);
  const user = state.emailId?.split("@")[0]?.toUpperCase();
  const [vehiclesList, setVehiclesList] = useState([]);
  const [showGateIn, setShowGateIn] = useState(false);
  const [date, setDate] = useState(new Date().toISOString());
  const [vehicleNo, setVehicleNo] = useState("");
  const [jobId, setJobId] = useState("");
  const [jobOpenDate, setJobOpenDate] = useState(new Date().toISOString());
  const [jobOpenTime, setJobOpenTime] = useState(
    new Date().toLocaleTimeString()
  );
  const [problemsReported, setProblemsReported] = useState("");

  const [taskName, setTaskName] = useState("");
  const [taskId, setTaskId] = useState("");
  const [taskStatus, setTaskStatus] = useState("");

  const [jobTasksList, setJobTaskList] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [taskList, setTaskList] = useState([]);

  const [currentTime, setCurrentTime] = useState(
    new Date().toLocaleTimeString()
  );
  const [driversList, setDriversList] = useState([]);
  const [driverName, setDriverName] = useState("");

  const VehicleDepartment = useSelector(
    (state) => state?.VehicleDepartmentReducer
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date().toLocaleTimeString());
      setJobOpenTime(new Date().toLocaleTimeString());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const filteredData = vehiclesList.filter((item) => {
    const searchData = search.toLowerCase().split(" ").filter(Boolean);

    if (searchData.length === 0) {
      return true;
    }

    const textMatch = searchData.every((term) => {
      return [
        "VEHICLE REG NO",
        "DRIVERNAME",
        "MAKE",
        "MODEL",
        "TRAILER NAME ATTACHED",
      ].some((key) => {
        const columnValue = String(item[key]).toLowerCase();
        return columnValue.includes(term);
      });
    });

    return textMatch;
  });

  useEffect(() => {
    initialData();
  }, []);

  const initialData = () => {
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1080`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setJobId(response?.data[0]?.NEW_JOB_ID);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Charges details:", error);
      });

    // Task List
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1097`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setTaskList(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Task List:", error);
      });

    // Driver's List  345;
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=345`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setDriversList(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Driver details:", error);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=671`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        if (VehicleDepartment !== "") {
          const filterData = response?.data?.filter(
            (item) =>
              item.VEHICLESTATE === "SENT TO WORKSHOP" &&
              item?.DEPARTMENT === VehicleDepartment
          );
          setVehiclesList(filterData);
        } else {
          const filterData = response?.data?.filter(
            (item) => item.VEHICLESTATE === "SENT TO WORKSHOP"
          );
          setVehiclesList(filterData);
        }
        setisloading(false);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Charges details:", error);
      });
  };

  // Saving
  async function SaveGateIn() {
    setisloading(true);
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1082`,
        {
          OT_JOB_ID: Number(jobId),
          OT_JOB_VEHICLE: vehicleNo,
          OT_JOB_OPEN_DATE: moment(jobOpenDate).format("YYYY/MM/DD"),
          OT_JOB_OPEN_TIME: jobOpenTime,
          OT_JOB_OPEN_BY: user,
          OT_JOB_PROBLEMS_REPORTED: problemsReported,
          OT_JOB_STATUS: "OPEN",
          OT_JOB_CLOSED_DATE: "",
          OT_JOB_CLOSED_TIME: "",
          OT_JOB_CLOSED_BY: "",
          OT_JOB_CLOSED_NARRATION: "",
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        }
      );

      if (response.status === 201) {
        setisloading(false);
        alert(`Job Header Saved successfully`);
        console.log(`Job Header Saved successfully`);
        await SaveTasks();
        await SaveVehicleState();
        await SaveState();
      } else {
        setisloading(false);
        console.error(`Error while saving Job Header`);
      }
    } catch (error) {
      setisloading(false);
      console.error(`Error while saving Job Header`, error);
    }
  }

  async function SaveTasks() {
    setisloading(true);
    let successCount = 0;
    let successMessage = null;
    let errorCount = 0;
    let errorMessage = null;
    for (let index = 0; index < jobTasksList.length; index++) {
      const value = jobTasksList[index];
      try {
        const response = await axios.post(
          `${BASEURL_GLOBAL}/globalSpHandler?spname=1083`,
          {
            OT_JOB_ID: Number(jobId),
            OT_JOB_TASK_ID: Number(value?.OT_JOB_TASK_ID),
            OT_JOB_TASK_STATUS: value.OT_JOB_TASK_STATUS,
            OT_JOB_TASK_STATUS_UPDATED_BY: user,
            OT_JOB_TASK_START_DATE: moment(date).format("YYYY/MM/DD"),
            OT_JOB_TASK_START_DATE_UPDATED_BY: user,
            OT_JOB_TASK_END_DATE: "",
            OT_JOB_TASK_END_DATE_UPDATED_BY: "",
          },
          {
            headers: {
              "auth-token": authToken,
              "session-token": sessionToken,
            },
          }
        );

        if (response.status === 201) {
          successCount++;
          successMessage = response.data.message;
        } else {
          errorCount++;
          errorMessage = response.data.message;
        }
      } catch (error) {
        setisloading(false);
        console.error(`Error while Saving Tasks`, error);
        alert(error.response.data.message);
      }
    }
    setisloading(false);
    if (successCount == jobTasksList.length && successMessage) {
      //   alert(successMessage);
      alert("Tasks for the Job Saved Successfully");
    }
    if (errorMessage) {
      alert(errorMessage);
    }
  }

  async function SaveVehicleState() {
    setisloading(true);
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1053`,
        {
          OT_VEHICLE_REG_NO: vehicleNo,
          OT_VEHICLE_STATE: "JOB IN WORKSHOP",
          OT_VEHICLE_STATE_DATE: moment(date).format("YYYY/MM/DD"),
          OT_VEHICLE_STATE_TIME: currentTime,
          OT_VEHICLE_PREVIOUS_STATE: "SENT TO WORKSHOP",
          OT_VEHICLE_STATE_UPDATED_BY: user,
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        }
      );

      if (response.status === 201) {
        setisloading(false);
        alert(`Vehicle State Updated successfully`);
        console.log(`Vehicle State Updated successfully`);
      } else {
        setisloading(false);
        console.error(`Error while saving Vehicle State`);
      }
    } catch (error) {
      setisloading(false);
      console.error(`Error while saving Vehicle State `, error);
    }
  }

  async function SaveState() {
    setisloading(true);
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1121`,
        {
          TRANSTYPE: "JOB IN WORKSHOP",
          DOC_NO: Number(jobId),
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        }
      );

      if (response.status === 201) {
        setisloading(false);
        alert(`State Updated successfully`);
        console.log(`State Updated successfully`);
      } else {
        setisloading(false);
        console.error(`Error while saving State`);
      }
    } catch (error) {
      setisloading(false);
      console.error(`Error while saving State `, error);
    }
  }

  // **************************************** Adding Items To Grid ********************************
  const AddItemsToGrid = () => {
    if (!taskName) {
      alert("Please select Task");
    } else if (!taskStatus) {
      alert("Kindly Provide the Task Status");
    } else {
      const newItem = {
        OT_JOB_TASK_ID: taskId,
        OT_JOB_TASK_NAME: taskName,
        OT_JOB_TASK_STATUS: taskStatus,
      };
      const existingRowIndex = jobTasksList.findIndex(
        (charge) => charge.OT_JOB_TASK_ID === newItem.OT_JOB_TASK_ID
      );

      if (existingRowIndex !== -1) {
        const updatedItems = [...jobTasksList];
        updatedItems[existingRowIndex] = newItem;
        setJobTaskList(updatedItems);
      } else {
        setJobTaskList([...jobTasksList, newItem]);
      }

      setShowTable(true);
      clearallinputs();
    }
  };

  const clearallinputs = () => {
    setSelectedRowIndex(null);
    setTaskName("");
    setTaskId("");
    setTaskStatus("");
  };

  const RemoveItems = () => {
    const updatedValues = [...jobTasksList];
    if (updatedValues.length === 0) {
      alert("There is no Tasks to be removed");
      setShowTable(false);
    } else {
      if (
        selectedRowIndex !== null &&
        selectedRowIndex >= 0 &&
        selectedRowIndex < updatedValues.length
      ) {
        updatedValues.splice(selectedRowIndex, 1);
        setSelectedRowIndex(null);
      } else {
        updatedValues.pop();
      }
      setJobTaskList(updatedValues);
      clearallinputs();
      if (updatedValues.length === 0) {
        setShowTable(false);
      }
    }
  };

  const handleRowClick = (value, index) => {
    setDriverName(value["DRIVERNAME"]);
    setVehicleNo(value["VEHICLE REG NO"]);
    setShowGateIn(true);
  };

  if (isloading) {
    return <LoadingScreen />;
  }

  return (
    <div className="min-h-screen p-4">
      <div className="flex justify-between">
        <h1 className="lg:text-3xl font-extrabold underline text-blue-600">
          Vehicles Expected In Workshop
        </h1>
        <FaArrowLeft
          className="cursor-pointer hover:text-blue-300 transition-all"
          size={30}
          onClick={() => {
            window.history.back();
          }}
        />
      </div>

      <div className="select_product_type" style={{ marginTop: "5px" }}>
        <div>
          <p>Search</p>
        </div>
        <div>
          <input
            type="text"
            className="w-64 h-8 border border-black rounded-md"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          ></input>
        </div>
      </div>

      <div className="visible lg:h-[500px] p-1 z-0 lg:overflow-auto mt-2">
        <table className="w-full border border-gray-300 text-sm">
          <thead className="sticky top-0">
            <tr className="bg-[#2b3f5c] text-white text-[12px]">
              <td className="py-2 px-4 text-right border border-gray-300">
                SNO
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                VEHICLE REG NO
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                DRIVER NAME
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                MAKE
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                MODEL
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                TRAILER ATTACHED ?
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                ATTACHED NAME TRAILER
              </td>
            </tr>
          </thead>
          <tbody>
            {filteredData.map((value, index) => (
              <tr
                key={index}
                className="hover:bg-gray-100 cursor-pointer text-[13px]"
                onClick={() => handleRowClick(value, index)}
              >
                <td className="py-2 px-4 text-right border border-gray-300">
                  {index + 1}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value["VEHICLE REG NO"] || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value["DRIVERNAME"] || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value.MAKE || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value.MODEL || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value["TRAILER ATTACHED"] === true
                    ? "YES"
                    : value["TRAILER ATTACHED"] === false
                    ? "NO"
                    : "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value["TRAILER NAME ATTACHED"] || "N/A"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* PopUp */}
      {showGateIn && (
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[100] bg-white border border-black lg:h-[400px] h-[80%] lg:w-[1000px] w-[95%] p-1 overflow-y-auto rounded-md">
          <h1 className="lg:text-3xl font-bold flex lg:justify-center justify-start">
            VEHICLES IN WORKSHOP
          </h1>

          {/* Row 1 */}
          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2">Job Id:</p>
            <input
              className="w-20 text-right h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={jobId}
              readOnly
            ></input>

            <p className="text-red-600 lg:ml-6">Vehicle:</p>
            <input
              className="w-32 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={vehicleNo}
              readOnly
            ></input>

            <p className="text-red-600 lg:ml-6">Job Open Date :</p>
            <input
              className="w-32 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="date"
              value={jobOpenDate?.split("T")[0]}
              readOnly
            ></input>

            <p className="text-red-600 lg:ml-6">Job Open Time :</p>
            <input
              className="w-32 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={jobOpenTime}
              readOnly
            ></input>
          </div>

          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2">Problem Reported :</p>
            <textarea
              rows={2}
              className="lg:w-[450px] w-[370px] resize-none border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={problemsReported}
              onChange={(e) => setProblemsReported(e.target.value)}
            ></textarea>
            <p className="text-red-600 lg:ml-2">Driver :</p>
            <Select
              className="lg:w-64 w-64 lg:ml-2"
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                menu: (base) => ({ ...base, zIndex: 9999 }),
              }}
              value={
                driverName
                  ? { value: driverName, label: driverName }
                  : { value: "", label: "Select Driver" }
              }
              onChange={(e) => {
                setDriverName(e.label);
                // setDriverCode(e.value);
              }}
              options={[
                { value: "", label: "Select Driver" },
                ...driversList?.map((item) => ({
                  value: item.DRIVERNAME,
                  label: item.DRIVERNAME,
                })),
              ]}
            ></Select>
          </div>

          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2">Task Name :</p>
            <Select
              className="w-64 lg:ml-2"
              value={
                taskName
                  ? { value: taskName, label: taskName }
                  : { value: "", label: "Select Task" }
              }
              onChange={(e) => {
                if (e.value !== "") {
                  setTaskName(e.value);
                  const compliance = taskList.find(
                    (item) => item.OM_ACTION_NAME === e.value
                  );
                  setTaskId(compliance?.OM_ACTION_ID);
                } else {
                  setTaskName("");
                }
              }}
              options={[
                { value: "", label: "Select Compliance" },
                ...taskList.map((item) => ({
                  label: item?.OM_ACTION_NAME,
                  value: item?.OM_ACTION_NAME,
                })),
              ]}
            ></Select>

            <p className="text-red-600 lg:ml-2">Status :</p>
            <Select
              className="w-64 lg:ml-1"
              value={
                taskStatus
                  ? { value: taskStatus, label: taskStatus }
                  : { value: "", label: "Select Task Status" }
              }
              onChange={(e) => {
                setTaskStatus(e.value);
              }}
              options={[
                { value: "", label: "Select Task Status" },
                { value: "NOT STARTED", label: "NOT STARTED" },
                { value: "STARTED", label: "STARTED" },
                { value: "COMPLETED", label: "COMPLETED" },
              ]}
            ></Select>
            <button
              className="lg:flex block my-1 h-[30px] items-center justify-center border border-black bg-[#002d62]  text-white rounded-md px-3 py-1 lg:ml-2 focus:outline-none focus:ring focus:border-blue-300"
              onClick={() => {
                AddItemsToGrid();
              }}
            >
              Add
            </button>

            <button
              className="lg:flex block my-1 h-[30px] items-center justify-center border border-black bg-[#002d62]  text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
              onClick={() => {
                RemoveItems();
              }}
            >
              Remove
            </button>
          </div>

          <div className="lg:w-full h-auto p-1">
            {showTable && (
              <aside className="table__pos__app text-[14px] lg:w-[98%] ">
                <table className="w-full border border-gray-300 text-sm">
                  <thead className="sticky top-0">
                    <tr className="bg-[#2b3f5c] text-white text-[12px]">
                      <td className="py-2 px-4 text-right border border-gray-300">
                        Task Id
                      </td>
                      <td className="py-2 px-4 text-left border border-gray-300">
                        Task Name
                      </td>
                      <td className="py-2 px-4 text-left border border-gray-300">
                        Status
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    {jobTasksList.map((value, index) => (
                      <tr
                        className="hover:bg-gray-100 cursor-pointer text-[13px]"
                        onClick={() => {
                          setTaskId(value?.OT_JOB_TASK_ID);
                          setTaskName(value?.OT_JOB_TASK_NAME);
                          setTaskStatus(value?.OT_JOB_TASK_STATUS);
                        }}
                      >
                        <td className="py-2 px-4 text-right border border-gray-300">
                          {value.OT_JOB_TASK_ID ? value.OT_JOB_TASK_ID : ""}
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          {value.OT_JOB_TASK_NAME ? value.OT_JOB_TASK_NAME : ""}
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          {value.OT_JOB_TASK_STATUS
                            ? value.OT_JOB_TASK_STATUS
                            : ""}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </aside>
            )}
          </div>

          <button
            className="absolute top-2 right-20 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
            onClick={async () => {
              if (!problemsReported) {
                alert("Kindly Supply Problem Reported");
                return;
              } else if (jobTasksList.length === 0) {
                alert("Kindly Add the tasks");
                return;
              } else {
                await SaveGateIn();
                setShowGateIn(false);
                window.location.reload();
              }
            }}
          >
            SAVE
          </button>

          <button
            className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
            onClick={() => setShowGateIn(false)}
          >
            Close
          </button>
        </div>
      )}
    </div>
  );
};

export default VehiclesExpectedInWorkshop;
